module.exports = __webpack_public_path__ + "assets/img/a25caac869aaa90c732848ab4ac1305e.svg";